import { useEffect, useRef, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './styles.scss'

const AccordionFAQ = ({ item, index, containerClassname }) => {
    const [showAnswer, setShowAnswer] = useState(false);
    const contentRef = useRef(null);

    const onShowAnswer = () => {
        setShowAnswer(!showAnswer);
    };

    // Auto-update maxHeight when the window is resized (keeps it responsive)
    useEffect(() => {
        if (!contentRef.current) return;
        const el = contentRef.current;
        const resizeObserver = new ResizeObserver(() => {
            if (showAnswer) {
                el.style.maxHeight = el.scrollHeight + 'px';
            }
        });
        resizeObserver.observe(el);
        return () => resizeObserver.disconnect();
    }, [showAnswer]);

    useEffect(() => {
        if (contentRef.current) {
            if (showAnswer) {
                contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
            } else {
                contentRef.current.style.maxHeight = '0px';
            }
        }
    }, [showAnswer]);

    return (
        <div key={index} className={containerClassname}>
            <div className="faq-acc-head" role="button" onClick={onShowAnswer}>
                <span className="faq-title">Q</span>
                <span className="faq-quest">{item?.question}</span>
                <div className="btnImg">
                    {showAnswer ? <div className="icon-toggle minus"></div>
                        : <div className="icon-toggle plus"></div>
                    }

                </div>
            </div>

            <div ref={contentRef} className="faq-acc-content">
                <div className="a-label">A</div>
                <div className="faq-acc-content-right">{ReactHtmlParser(item?.answer)}</div>
            </div>
        </div>
    );
};

export default AccordionFAQ;